import { InitCookie } from '@patsnap/init-cookie';

export const SELF_ENTRY_CHANNEL = 'ip_detail_page_drafting';

export const entryCookie = new InitCookie({
    entry_channel: SELF_ENTRY_CHANNEL,
});

export const initCookie = InitCookie;
